"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mq = exports.theme = void 0;
var facepaint_1 = __importDefault(require("facepaint"));
// theme object
// schema: https://theme-ui.com/theme-spec/
var theme = {
    colors: {
        // SEMANTIC
        primary: "#F6D99F",
        white: "#FFFFFF",
        black: "#000000",
        red: "#E96363",
        orange: "#D7971F",
        yellow: "#FFF66D",
        green: "#00DAA6",
        blue: "#7096B9",
        error: "#834E2E",
        lightGold: "#F6D99F",
        darkGold: "#DEB566",
        darkGray: "#150F04",
        // GRAYSCALE
        gray000: "#FFFFFF",
        gray100: "#FAFAFA",
        gray200: "#F5F5F5",
        gray300: "#E9E9E9",
        gray400: "#D9D9D9",
        gray500: "#AFAFAF",
        gray600: "#737373",
        gray700: "#2F2F2F",
        gray800: "#1E1E1E",
        gray900: "#150F04",
        // GOLD
        gold000: "#FFF4E6",
        gold100: "#FBE5C2",
        gold200: "#F6D99F",
        gold300: "#E3C37E",
        gold400: "#DEB566",
        gold500: "#AF8E38",
        gold600: "#8D701F",
        gold700: "#6A5410",
        gold800: "#483808",
        gold900: "#261E04",
        // ORANGE
        orange000: "#FFEACC",
        orange100: "#FCDAA9",
        orange200: "#F8CC88",
        orange300: "#F2BD67",
        orange400: "#ECAF48",
        orange500: "#D7971F",
        orange600: "#B78414",
        orange700: "#8A670E",
        orange800: "#57430A",
        orange900: "#261E06",
        // BLUE
        blue000: "#EBF3F7",
        blue100: "#DBEBF4",
        blue200: "#CAE3F1",
        blue300: "#BAD8EC",
        blue400: "#AACDE6",
        blue500: "#8CB3D4",
        blue600: "#7096B9",
        blue700: "#557194",
        blue800: "#3A4C69",
        blue900: "#232D40",
        // YELLOW
        yellow000: "#FFF9D9",
        yellow100: "#FFF7C4",
        yellow200: "#FFF5B0",
        yellow300: "#FFF59E",
        yellow400: "#FFF68B",
        yellow500: "#FFF66D",
        yellow600: "#FAEF53",
        yellow700: "#F1E741",
        yellow800: "#DBD531",
        yellow900: "#99991F",
        // GREEN
        green000: "#C6F7DF",
        green100: "#A9F8D4",
        green200: "#8BF9CC",
        green300: "#6CF8C3",
        green400: "#4DF7BE",
        green500: "#28ECB5",
        green600: "#00DAA6",
        green700: "#19B692",
        green800: "#208D74",
        green900: "#1D6655",
        // RED
        red000: "#FFC7C2",
        red100: "#FAAEA9",
        red200: "#F49492",
        red300: "#EF7B7A",
        red400: "#E96363",
        red500: "#C76658",
        red600: "#A55F46",
        red700: "#834E2E",
        red800: "#623713",
        red900: "#402000",
        // SPECIAL
        blue24: "#2188E63D",
        green24: "#3ECC993D",
        tomato24: "#DD44443D",
        black4: "#14141566",
    },
    space: ["4px", "8px", "16px", "24px", "40px", "64px", "80px"],
    breakpoints: ["750px", "1024px"],
};
exports.theme = theme;
// aliases
theme.breakpoints.mobile = theme.breakpoints[0];
theme.breakpoints.desktop = theme.breakpoints[1];
theme.space.xxsmall = theme.space[0];
theme.space.xsmall = theme.space[1];
theme.space.small = theme.space[2];
theme.space.medium = theme.space[3];
theme.space.large = theme.space[4];
theme.space.xlarge = theme.space[5];
theme.space.xxlarge = theme.space[6];
// utils
var mq = (0, facepaint_1.default)(theme.breakpoints.map(function (bp) { return "@media (min-width: ".concat(bp, ")"); }));
exports.mq = mq;
